const scrollIntoView = targetId => {
  const pageElement = document.getElementById(targetId);
  if (pageElement) {
    pageElement.scrollIntoView({ behavior: 'smooth' });
  }
};

export default scrollIntoView;
